<script>
export default {
  computed: {
    items() {
      const steps = [
        {
          key: 'CREATE',
          title: 'Crear sucursal',
          body: 'Nombre y descripción',
          route: 'settings_branches_new',
        },
        {
          key: 'ADD_AGENTS',
          title: 'Agregar agentes',
          body: 'Selecciona los agentes',
          route: 'settings_branches_add_agents',
        },
        {
          key: 'ADD_TEAMS',
          title: 'Agregar equipos',
          body: 'Selecciona los equipos',
          route: 'settings_branches_add_teams',
        },
        {
          key: 'FINISH',
          title: 'Finalizar',
          body: 'Sucursal lista',
          route: 'settings_branches_finish',
        },
      ];

      return steps.map(step => {
        return {
          title: step.title,
          body: step.body,
          route: step.route,
        };
      });
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-6 mb-8 max-w-7xl mx-auto w-full !px-6">
    <div
      class="grid grid-cols-1 lg:grid-cols-8 lg:divide-x lg:divide-n-weak rounded-xl border border-n-weak h-full min-h-[50dvh] w-full"
    >
      <woot-wizard
        class="hidden lg:block col-span-2 h-fit py-8 px-6"
        :items="items"
      />
      <router-view />
    </div>
  </div>
</template>
